import React from 'react'

class DoubleFreeDepositEvent extends React.PureComponent {
  onClickJump = () => {
    window.location.href = '/signup?utm_source=guanwang&utm_medium=banner&utm_campaign=DuanZu'
  }
}

export default DoubleFreeDepositEvent
